import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import close from "../../Assets/svg/close-cross.svg";
import sad from "../../Assets/svg/sad.svg";
import { useDispatch, useSelector } from "react-redux";
import { doLogout } from "../LoginPage/redux/actions";

import { api } from "../../Services";
import { resetState } from "../PersonalInfo/redux/actions";
import { resetIncome } from "../IncomeDetails/redux/actions";
import { resetEdu } from "../Education/redux/actions";
import { resetRegister } from "../Register/redux/actions";
import { resetApp } from "../ApplicationForm/redux/actions";
import { resetQueries } from "../Queries/redux/actions";
import { resetStatus } from "../WelcomeBack/redux/actions";
import { clearDisburse } from "../DisburseForm/redux/actions";
import { resetClear } from "../Connect/redux/actions";
import { GetLogout } from "./Logout";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function ModalComponent(props) {
  const [open, setOpen] = useState(props?.show || false);
  const [timeLeft, setTimeLeft] = useState(300); // 300 seconds = 5 minutes
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const dispatch = useDispatch();
  const tokenData = useSelector((state) => state.tokens.tokens);
  const personalInfo = useSelector((state) => state.personal.personalInfo);

  const getLogout = async () => {
    // const personalInfo = useSelector((state) => state.personal.personalInfo);
    // const dispatch = useDispatch();
    // const tokenData = useSelector((state) => state.tokens.tokens);

    try {
      let users = await api.logout(tokenData.token, personalInfo?.mobile);
      console.log('logout api', users)
      // if (users.statusCode == 200) {
        dispatch(resetState());
        dispatch(resetIncome());
        dispatch(resetEdu());
        dispatch(resetRegister());
        dispatch(resetApp());
        dispatch(resetQueries());
        dispatch(resetStatus());
        dispatch(clearDisburse());
        dispatch(resetClear());
        dispatch(doLogout());
      // }
      // return users;
    } catch (error) {
      console.error("Error logging out:", error);

      //   } finally {
      // setIsLoading(false);
    }
  };

  const logoutMsg = async() => {
    // let users=await getLogout();
    let users = await getLogout()
    console.log('logout api', users)
    console.log("u have been logged out");
  };
  useEffect(() => {
    if (timeLeft === 0) {
      console.log("timer done");
      if (typeof props?.title === 'string' && props?.title?.includes("Are you there ?")) {
        // dispatch(doLogout());
      logoutMsg();

      }
    }

    const intervalId = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timeLeft]);
  useEffect(() => {
    setOpen(props.show);
  }, [props.show]);
  return (
    <div>
      {/* <Button onClick={handleOpen}>Open modal</Button> */}
      <Modal
        open={open}
        className={props?.className}
        onClose={() => props?.handleClose()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className={props?.className}>
          {!props.noCross && (
            <div className="close-icon" onClick={() => props.handleClose()}>
              <img src={close} alt="close icon" />
            </div>
          )}
          {props?.type === "logout" && (
            <div className="sad-image">
              <img src={sad} alt="close icon" />
            </div>
          )}
          <Typography
            id="modal-modal-title"
            className="md-title"
            variant="h6"
            component="h2"
          >
            {props?.title}
          </Typography>
          {props?.content && <Typography
            id="modal-modal-description"
            className="md-desc"
            sx={{ mt: 2 }}
          >
            {props?.content}
          </Typography>}
          

          {props?.children}
        </Box>
      </Modal>
    </div>
  );
}
